import * as React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../core/redux/appState';
import { TextDirection } from './textDirection';
import { strictEquals } from '../language/module';


interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  forceDirection?: TextDirection;
}


/**
 * LocalDiv: a div component that accepts all the normal div props and renders in the layout direction given by
 * the Text Direction in Redux (taken from the user's locale).
 *
 * Layout direction only changes for horizontally-arranged content. If you make your div a flex column e.g., direction
 * is unchanged by layout direction changes.
 *
 * PureComponent: true
 * Redux Connected: true
 */
const LocalDiv: React.FC<Props> = props => {
  // React complains if you forward unknown props to HTML elements *eye-roll*
  const { forceDirection, ...rest } = props;

  const layoutDirection = useSelector<AppState, TextDirection>(
    state => state.locale.textDirection,
    strictEquals,
  );

  return (
    <div {...rest} dir={forceDirection ?? layoutDirection} />
  );
};

export default LocalDiv;
